    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-body">
                    <h4 class="card-title mb-4">Indicadores</h4>
                    <div class="table-responsive mb-0">
                      <table class="table table-centered table-nowrap">
                        <tbody>
                          <tr *ngFor="let panel of Paneles">
                            <td>{{panel.TITULO}}</td>
                            <td>{{panel.VALOR}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!-- end table -->
                </div>
            </div>
        </div>

    </div>

